export type CursorPosition = {
  element: HTMLElement;
  fieldName: string;
  cursorPosition?: number;
  selectionStart?: number;
  selectionEnd?: number;
};

export const editorsSelector =
  '.jodit-wysiwyg, .toastui-editor, .codex-editor__redactor';

export const elementHasSelection = (
  element: HTMLElement,
): element is HTMLInputElement | HTMLTextAreaElement => {
  return (
    element instanceof HTMLInputElement ||
    element instanceof HTMLTextAreaElement
  );
};

const getFieldName = (target: HTMLElement) => {
  if (target.getAttribute('name')) return target.getAttribute('name');
  if (target.getAttribute('contenteditable')) {
    const parentElement = target.closest('[data-field-name]');
    if (parentElement) {
      return parentElement.getAttribute('data-field-name');
    }
  }
  return null;
};

export const getCursor = (event: FocusEvent) => {
  if (!event.target) return;

  const target = event.target as HTMLElement;
  const fieldName = getFieldName(target);

  if (!fieldName) return;

  let cursorPosition;
  let selectionStart;
  let selectionEnd;

  if (target.closest(editorsSelector)) {
    const selection = window.getSelection();

    if (selection && selection.rangeCount > 0) {
      const range = selection.getRangeAt(0);
      const parentElement = target.closest(editorsSelector) || target;

      const walker = document.createTreeWalker(
        parentElement,
        NodeFilter.SHOW_TEXT,
      );

      let currentPos = 0;
      let node = walker.nextNode();

      while (node) {
        if (range.startContainer.contains(node)) {
          cursorPosition = currentPos + range.endOffset;
          break;
        }
        currentPos += node.textContent?.length || 0;
        node = walker.nextNode();
      }
    }
  } else if (
    elementHasSelection(target) &&
    typeof target.selectionEnd === 'number' &&
    typeof target.selectionStart === 'number'
  ) {
    selectionStart = target.selectionStart;
    selectionEnd = target.selectionEnd;
  }

  return {
    element: target,
    fieldName,
    cursorPosition,
    selectionStart,
    selectionEnd,
  };
};
